import { PdpState } from '@ff-os/pdp-shared-redux/store';
import { scenePlugins } from '@ff-os/pdp-shared-registry/index';

export const generateArPreviewThumbnail = async (state: PdpState) => {
    const plugin = scenePlugins.require(state.scene.pluginId);
    const thumbnail = await plugin.renderThumbnail(state, { width: 256, height: 256 }, { includeBackground: false });
    return await thumbnail.toBase64();
};